export const DEFAULT_COUNTRY_CODE = 'ES'
export const DEFAULT_CATEGORY_INDEX = 0
